import { createRouter, createWebHistory } from 'vue-router';
import { findIndex } from 'lodash'; // Make sure you have Lodash installed

import store from '../store/store';
import { getTestUserToken, getUserLevel, getUserInfo } from '../api/user';

// Import route modules
import commonRoutes from './common';
import mainRoutes from './main';
import onboardingRoutes from './onboarding';
import onboardingDemoRoutes from './demo';
import dimensionRoutes from './dimension';
import conversionRoutes from './conversion';
import warningRoutes from './warning';
import kpiRoutes from './kpi';
import goalsRoutes from './goals';
import actionRoutes from './action';
import integratedRoutes from './integrated';
import marketGoalsRoutes from './market-goals';
import weeklyReportsRoutes from './weekly-reports';

const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: '/',
      name: 'home',
      // This can be a temporary component or leave it blank as we will handle redirection in beforeEach
      component: { template: '<div>Redirecting...</div>' },
    },
    ...commonRoutes,
    ...mainRoutes,
    ...onboardingRoutes,
    ...onboardingDemoRoutes,
    ...dimensionRoutes,
    ...kpiRoutes,
    ...goalsRoutes,
    ...actionRoutes,
    ...conversionRoutes,
    ...warningRoutes,
    ...integratedRoutes,
    ...marketGoalsRoutes,
    ...weeklyReportsRoutes,
  ],
});

router.beforeEach(async (to, from, next) => {
  try {
    // Cancel previous requests
    const cancelTokenMap = store.getters.getCancelToken;
    const cancelList = Object.entries(cancelTokenMap || {});
    cancelList.forEach(([key, cancelFn]) => {
      cancelFn(); // Execute cancel function
      if (cancelTokenMap[key]) {
        store.commit('deleteCancelToken', key);
      }
    });

    const personalProfile = store.getters.getPersonalProfile;
    const accountGroupId = store.getters.getAccountgroupID;
    const { hasSeenIntro, initialGroupConfigured } = personalProfile;
    const token = store.getters.getToken;
    const accountGroupStatus = store.getters.getAccountGroupStatus;
    if (accountGroupStatus === 'process') {
      store.commit('setPersonalProfile', { hasSeenIntro, initialGroupConfigured: false });
    }

    let role = 1 + hasSeenIntro + initialGroupConfigured;

    const whiteRouteNameList = [
      'login',
      'callback',
      'shopify-login',
      'protocol',
      'demo',
      'account-group',
      'connect-platform',
      'shopify-bind',
      'shopify-bind-success',
    ];

    if (to.path === '/settings/setting' && to.query.accountGroupId && to.query.shop) {
      if (!accountGroupId || accountGroupId !== to.query.accountGroupId) {
        return next({ path: '/shopify-bind-success', query: to.query });
      }
    }

    if (to.fullPath === '/' && token) {
      await getUserInfo();
      return next('/integrated/overview');
    }

    if (to.path === '/' && to.query.accountGroupId) {
      const tokenResult = await getTestUserToken({ accountGroupId: to.query.accountGroupId });
      const tempPersonalProfile = { hasSeenIntro: true, initialGroupConfigured: true };
      let customerLevel = to.query.level;

      if (to.query.addNew) {
        tempPersonalProfile.hasSeenIntro = to.query.addNew === '2';
        tempPersonalProfile.initialGroupConfigured = false;
      }

      store.commit('setPersonalProfile', tempPersonalProfile);
      store.commit('commitAccountgroupID', to.query.accountGroupId);
      store.commit('setToken', tokenResult.token);

      role = 1 + tempPersonalProfile.hasSeenIntro + tempPersonalProfile.initialGroupConfigured;

      if (to.query.authorizedPlatform && role === 3) {
        return next({ path: '/settings/setting' });
      }

      if (!to.query.level) {
        const result = await getUserLevel(to.query.accountGroupId);
        customerLevel = result.customer_level;
      }

      store.commit('setCustomerLevel', customerLevel);
    } else if (to.path === '/' || (!token && !whiteRouteNameList.includes(to.name))) {
      return next('/login');
    }

    console.log('ROLE NUMBER', to.meta.role, 'ROLE', role)
    if (!to.meta || findIndex(to.meta.role, o => o === 0) !== -1) {
      return next();
    } else if (findIndex(to.meta.role, o => o === role) !== -1) {
      return next();
    } else {
      console.log('Straight to hell!')
      switch (role) {
        case 1:
          return next('/onboarding/step2-3');
        case 2:
          return next('/onboarding/step3-connect-platform');
        case 3:
          return next('/integrated/overview');
        default:
          return next('/login');
      }
    }
  } catch (error) {
    console.error('Navigation error:', error);
    next(error);
  }
});

export default router;
